import { useCallback } from 'react';
import { Alert, Box, Button, Text } from '@nimbus-ds/components';
import { useNavegate } from 'App/hooks';
import { useModal } from 'commons/hooks';
import { dateFormat, Format } from 'commons/utils/date';
import { usePlanDowngrade } from 'domains/Billing/BillingPlans/hooks';
import { trackingBillingCancelScheduledDowngradeClick } from 'domains/Billing/tracking';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import CancelDowngradeModal from '../CancelDowngradeModal';

export default function PlanDowngradeAlert() {
  const t = useTranslationBilling('billingPlansPage.planDowngradeAlert');
  const { scheduledDowngrade, isSuccess, oldPlanName, newPlanName } =
    usePlanDowngrade();
  const [showModal, openModal, closeModal] = useModal();
  const { pathname } = useNavegate();

  const handleOnClick = useCallback(() => {
    trackingBillingCancelScheduledDowngradeClick(pathname);
    openModal();
  }, [openModal, pathname]);

  if (!isSuccess || !scheduledDowngrade) return null;

  return (
    <>
      <Alert
        title={t('title', {
          oldPlanName,
          newPlanName,
        })}
      >
        <Box display="flex" flexDirection="column" gap="3">
          <Text>
            {t('message', {
              oldPlanName,
              newPlanName,
              scheduledAt: dateFormat(
                scheduledDowngrade.scheduledAt,
                Format.DD_MM,
              ),
            })}
          </Text>
          <Button onClick={handleOnClick}>{t('cancelButton')}</Button>
        </Box>
      </Alert>
      <CancelDowngradeModal open={showModal} onClose={closeModal} />
    </>
  );
}
